/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Status_Coach_ProgrammingInputs */

const fr_week_session_status_coach_programming = /** @type {(inputs: Week_Session_Status_Coach_ProgrammingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programmation coach`)
};

/**

* @param {Week_Session_Status_Coach_ProgrammingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_status_coach_programming = /** @type {((inputs?: Week_Session_Status_Coach_ProgrammingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Status_Coach_ProgrammingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_status_coach_programming(inputs)
});